import { render } from "./SmartGlassDetails.vue?vue&type=template&id=4ec3e39a&scoped=true"
import script from "./SmartGlassDetails.vue?vue&type=script&lang=js"
export * from "./SmartGlassDetails.vue?vue&type=script&lang=js"

import "./SmartGlassDetails.vue?vue&type=style&index=0&id=4ec3e39a&scoped=true&lang=css"

import exportComponent from "/home/azai-web/azaitech-website-template-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec3e39a"]])

export default __exports__